import { render } from "./img-box.vue?vue&type=template&id=2eb6e4b9"
import script from "./img-box.vue?vue&type=script&lang=js"
export * from "./img-box.vue?vue&type=script&lang=js"

import "./img-box.vue?vue&type=style&index=0&id=2eb6e4b9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/img-box.vue'],['render',render],['__file',"img-box.vue"]])

export default __exports__